import React from 'react';
import { defaultAvailableStates } from '@shared/carrierStateAvailability';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface StateOfResidenceSelectorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  availableStates?: readonly string[];
}

export const StateOfResidenceSelector: React.FC<StateOfResidenceSelectorProps> = ({
  value,
  onChange,
  placeholder = 'Select your state of residence',
  className = 'w-full text-gray-700',
  disabled = false,
  availableStates,
}) => {
  // Filter states based on availableStates prop if provided
  const displayStates = availableStates
    ? defaultAvailableStates.filter(state => availableStates.includes(state.value))
    : defaultAvailableStates;

  return (
    <div className="space-y-4">
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700">State of Residence</label>
        <p className="mb-3 text-sm text-gray-600">
          Long-term care insurance coverage and benefits may vary by state due to different
          regulations and requirements.
        </p>
        <Select
          value={value}
          onValueChange={onChange}
          disabled={disabled}
        >
          <SelectTrigger className={className}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {displayStates.map(state => (
              <SelectItem
                key={state.value}
                value={state.value}
              >
                {state.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
